var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-search",
    "data-name": "Icon awesome-search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.82,
    height: 30.825,
    viewBox: "0 0 30.82 30.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-search-2",
    "data-name": "Icon awesome-search",
    d: "M30.4,26.65l-6-6a1.444,1.444,0,0,0-1.023-.421h-.981a12.516,12.516,0,1,0-2.167,2.167v.981a1.444,1.444,0,0,0,.421,1.023l6,6a1.439,1.439,0,0,0,2.041,0l1.7-1.7A1.452,1.452,0,0,0,30.4,26.65ZM12.521,20.227a7.705,7.705,0,1,1,7.705-7.705A7.7,7.7,0,0,1,12.521,20.227Z",
    fill: "#b1b1b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.2cb4297dfde42d135db6e04a85a30a4b.svg";
export { ForwardRef as ReactComponent };